module.exports = __webpack_public_path__ + "img/scissors-02.4dfe7cf7.svg";